<div (click)="sendgGoolgeAuthAnalyticsEvent()">
  <capra-button-link
    class="connect-button"
    text="Connect your Google Account"
    data-test="connect-google-account"
    variant="secondary"
    color="neutral"
    icon="illo-google"
    [href]="googleAuthUri"
    target="_self"
  ></capra-button-link>
</div>
